<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :disabled="disabled"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    menu-props="offsetY"
    full-width
    min-width="290px"
    :return-value.sync="ranges"
  >
    <template v-slot:activator="{ on }">
      <v-combobox
        :value="modifiedDates"
        :style="{paddingTop: padding}"
        multiple
        chips
        small-chips
        :label="label"
        readonly
        :rules="rules"
        hide-details
        :outline="outline ? outline : true"
        :height="heightField ? heightField : 44"
        :error="error"
        class="mt-2"
        :prepend-inner-icon="hideDataTypeIcon ? '' : 'event'"
        v-on="on"
      >
        <template v-slot:selection="{ item, parent }">
          <v-chip small>
            <span class="pr-2">
              {{ item.text }}
            </span>
            <v-icon
              v-if="!disabled"
              small
              @click="removeRange(parent, item)"
            >
              close
            </v-icon>
          </v-chip>
        </template>
      </v-combobox>
    </template>
    <v-card class="v-date-range__pickers">
      <v-date-picker
        v-model="startData"
        no-title
        locale="ru-ru"
        scrollable
        :readonly="isReadonly"
        :min="min"
        :max="max || endData"
        class="mr-1"
        :events="highlightDates"
        :event-color="highlightClasses"
        first-day-of-week="1"
      />
      <v-date-picker
        v-model="endData"
        no-title
        locale="ru-ru"
        scrollable
        :readonly="isReadonly"
        :min="startData ? startData : min"
        :max="max"
        :events="highlightDates"
        :event-color="highlightClasses"
        first-day-of-week="1"
      />
      <v-card-actions>
        <v-btn
          flat
          color="primary"
          @click="()=>{menu = false;cleanRange();}"
        >
          Отмена
        </v-btn>
        <v-btn
          flat
          color="primary"
          :disabled="!bothSelected"
          @click="save"
        >
          Добавить диапазон
        </v-btn>
        <v-btn
          flat
          color="primary"
          :disabled="bothSelected"
          @click="saveDate"
        >
          Добавить дату
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: [
    "label",
    "value",
    "readonly",
    "min",
    "max",
    "rules",
    "padding",
    "disabled",
    "outline",
    "heightField",
    "error",
    "hideDataTypeIcon",
  ],
  data() {
    return {
      ranges: [],
      menu: false,
      startData: null,
      endData: null,
      highlightColor: "blue lighten-5",
      highlightDates: [],
      highlightClasses: {},
    };
  },
  computed: {
    isReadonly() {
      return this.readonly ? this.readonly : false;
    },
    modifiedDates() {
      const dates = [];

      this.ranges.forEach((item, index) => {
        if (item.range && item.range.length > 1) {
          const sortRange = item.range
            .map(date => {
              return this.moment(date.substr(0, 10)).unix();
            })
            .sort((a, b) => {
              return +a - +b;
            });
          dates.push({
            index,
            text: `${this.moment(sortRange[0] * 1000).format(
              "DD.MM.YY",
            )}-${this.moment(sortRange[sortRange.length - 1] * 1000).format(
              "DD.MM.YY",
            )}`,
          });
        } else if (item.range) {
          dates.push({
            index,
            text: `${this.moment(item.range[0].substr(0, 10)).format(
              "DD.MM.YY",
            )}`,
          });
        }
      });

      return dates;
    },
    bothSelected() {
      return this.startData !== null && this.endData !== null;
    },
  },
  watch: {
    value() {
      this.setDate();
    },
    menu() {
      if (this.menu) {
        this.$emit("opened");
      }
    },
    startData: "highlight",
    endData: "highlight",
  },
  created() {
    this.setDate();
  },
  methods: {
    setDate() {
      this.ranges = [];
      this.value.forEach(item => {
        if (item.range && Array.isArray(item.range)) {
          const mappedRanges = item.range.map(date => {
            return this.moment(date.substr(0, 10)).format("YYYY-MM-DD");
          });
          this.ranges.push({ range: mappedRanges });
        }
      });
    },
    save() {
      this.ranges.push({ range: this.highlightDates });
      this.cleanRange();
      this.$refs["menu"].save(this.ranges);
      this.changeModel();
    },
    saveDate() {
      const date = this.startData
        ? this.startData
        : this.endData
          ? this.endData
          : null;
      this.ranges.push({ range: [date] });
      this.cleanRange();
      this.$refs["menu"].save(this.ranges);
      this.changeModel();
    },
    removeRange(parent, item) {
      parent.selectItem(item);
      this.ranges.splice(item.index, 1);
      this.changeModel();
    },
    highlight() {
      if (!this.bothSelected) {
        return;
      }
      const dates = []; //массив дат диапазона
      const classes = {};
      const start = this.moment(this.startData).unix();
      const end = this.moment(this.endData).unix();
      const diff = Math.abs(start - end) / 86400; //берем разницу дней между стартовой и конечной датой

      for (let i = 0; i <= diff; i++) {
        const date = this.moment((start + 86400 * i) * 1000).format(
          "YYYY-MM-DD",
        ); //начиная со стартовой даты диапазона добавляем день, если i=0 получается начальная дата
        dates.push(date); //добавляем дату в массив
        const classesArr = [];
        classesArr.push("v-date-range__in-range");
        classesArr.push(this.highlightColor);
        i === 0 && classesArr.push("v-date-range__range-start");
        i === diff && classesArr.push("v-date-range__range-end");
        classes[date] = classesArr.join(" ");
      }
      this.highlightDates = dates;
      this.highlightClasses = classes;
    },
    cleanRange() {
      this.startData = null;
      this.endData = null;
      this.highlightDates = [];
      this.highlightClasses = {};
    },
    changeModel() {
      this.$emit("input", this.ranges);
    },
  },
};
</script>

<style scoped>
.v-date-range__pickers >>> .v-date-picker-table__events {
  height: 100% !important;
  width: 38px !important;
  top: 0 !important;
  z-index: -1 !important;
}

.v-date-range__pickers >>> .v-date-range__in-range {
  height: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  border-radius: 0 !important;
}

.v-date-range__pickers >>> .v-date-range__in-range.v-date-range__range-start {
  border-top-left-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.v-date-range__pickers >>> .v-date-range__in-range.v-date-range__range-end {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}
</style>

<style>
table .v-menu__activator .v-text-field .v-input__control .v-input__slot:before {
  border-style: none;
}
</style>
